import api from "./axiosInstance";

export const fetchClassesApi = (params: {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: "asc" | "desc";
  search: string;
  startDate?: string;
  endDate?: string;
}) => {
  return api.get("/admin/classes", {
    params: params,
  });
};

export const fetchClassesListApi = (params: {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: "asc" | "desc";
  search: string;
}) => {
  return api.get("/admin/classes/list", {
    params: params,
  });
};

export const fetchClassesForAttendanceApi = (params: {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: "asc" | "desc";
  search: string;
  startDate?: string;
  endDate?: string;
}) => {
  return api.get("/admin/classes/attendance", {
    params: params,
  });
};

export const fetchClassesDropdownApi = () => {
  return api.get("/admin/classes/dropdown");
};

export const createClassApi = (classData: any) =>
  api.post("/admin/classes", classData);

export const deleteClassApi = (classId: number) =>
  api.delete(`/admin/classes/${classId}`);

export const getClassApi = (classId: number) =>
  api.get(`/admin/classes/${classId}`);

export const updateClassApi = (classId: number, classData: any) =>
  api.patch(`/admin/classes/${classId}`, classData);
